// ============================================================
// FOOTER ACCORDION (Mobile Only)
// ============================================================

export function initFooterAccordion() {
    const footerHeadings = document.querySelectorAll('.footer-heading.has-arrow');
    if (footerHeadings.length === 0) return;

    const accordionBoxes = new Set();

    footerHeadings.forEach(heading => {
        const parentBox = heading.closest('.footer-box');
        const linksList = parentBox?.querySelector('.footer-content');
        if (!parentBox || !linksList) return;

        parentBox.classList.add('is-accordion');
        accordionBoxes.add(parentBox);

        heading.addEventListener('click', function () {
            if (window.innerWidth >= 768) return;

            parentBox.classList.toggle('active');

            linksList.style.height = parentBox.classList.contains('active')
                ? linksList.scrollHeight + 'px'
                : '0px';
        });
    });

    const syncAccordionState = () => {
        const isDesktop = window.innerWidth >= 768;

        accordionBoxes.forEach(box => {
            const content = box.querySelector('.footer-content');
            if (!content) return;

            if (isDesktop) {
                content.style.height = '';
                box.classList.remove('active');
            } else {
                content.style.height = box.classList.contains('active')
                    ? content.scrollHeight + 'px'
                    : '0px';
            }
        });
    };

    syncAccordionState();

    // Reset przy przejściu Mobile <-> Desktop
    window.addEventListener('resize', syncAccordionState);
}
